import { ModalComponentWrapper } from '@/shared/components';
import { useCountriesDictionary } from '@/shared/api';
import {
  type PhoneVerificationModalArgs,
  usePhoneVerificationForm,
} from '@/features/user-settings-phone/model';
import { PhoneVerificationForm } from '@/features/user-settings-phone/ui/PhoneVerificationForm';
import { type ReactNode, useMemo } from 'react';

interface PhoneVerificationModalProps extends PhoneVerificationModalArgs {
  content?: ReactNode;
}

export const PhoneVerificationModal = ({
  identity,
  onSuccess,
  content,
}: PhoneVerificationModalProps) => {
  const { countriesData, isCountriesLoading } = useCountriesDictionary();

  const {
    form,
    onSubmit,
    isSendTwoFactorIdentityLoading,
    sendTwoFactorIdentityError,
  } = usePhoneVerificationForm(countriesData?.value, onSuccess, identity);

  const validCountries = useMemo(() => {
    return (
      countriesData?.value.filter(country => country.phoneCode !== '') || []
    );
  }, [countriesData]);

  return (
    <ModalComponentWrapper>
      {content}
      <div className="flex flex-col gap-[1.6rem]">
        <PhoneVerificationForm
          form={form}
          onSubmit={onSubmit}
          isSendTwoFactorIdentityLoading={isSendTwoFactorIdentityLoading}
          sendTwoFactorIdentityError={sendTwoFactorIdentityError}
          isCountriesLoading={isCountriesLoading}
          validCountries={validCountries}
        />
      </div>
    </ModalComponentWrapper>
  );
};
